module.exports = __webpack_public_path__ + "_assets/img/video.caa367e8.svg";